import type { components } from '@/api/qraft/schema';
import type { LanguageCode } from '~/types/congregationGroupTypes';

type ApiLanguage = components['schemas']['Language'];

const API_TO_LOCALE: Record<ApiLanguage, LanguageCode> = {
  EN: 'en',
  ES: 'es',
  FR: 'fr',
  PT_BR: 'pt-br',
};

const LOCALE_TO_API: Record<LanguageCode, ApiLanguage> = {
  en: 'EN',
  es: 'ES',
  fr: 'FR',
  'pt-br': 'PT_BR',
};

export function apiLanguageToLocale(language: ApiLanguage): LanguageCode {
  return API_TO_LOCALE[language];
}

/**
 * The reverse, for surfaces that pass an explicit `language` query parameter,
 * such as the public course directory, which renders in the interface language
 * rather than the account language.
 */
export function localeToApiLanguage(locale: string): ApiLanguage {
  return LOCALE_TO_API[locale as LanguageCode] ?? 'EN';
}
